// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    top:0;
    left:0;
}
.overlay .mat-icon {
    visibility: hidden;
}
.overlay:hover {
    background-color: rgba(0,0,0,0.5);
}

.overlay:hover .mat-icon {
    visibility: visible;
    color:var(--primary-color);
}
.baseaction {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    height: 100%;
    width: 100%;
    text-align: center;
}

/*.baseActionMargin {
    margin: 10px;
}*/

.small {
    width: 32px;
    height: 32px;
}

.medium {
    width: 64px;
    height: 64px;
}

.large {
    width: 128px;
    height: 128px;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/actions/base.action.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,KAAK;IACL,MAAM;AACV;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;;EAEE;;AAEF;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".overlay {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top:0;\n    left:0;\n}\n.overlay .mat-icon {\n    visibility: hidden;\n}\n.overlay:hover {\n    background-color: rgba(0,0,0,0.5);\n}\n\n.overlay:hover .mat-icon {\n    visibility: visible;\n    color:var(--primary-color);\n}\n.baseaction {\n    display: flex;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n    text-align: center;\n}\n\n/*.baseActionMargin {\n    margin: 10px;\n}*/\n\n.small {\n    width: 32px;\n    height: 32px;\n}\n\n.medium {\n    width: 64px;\n    height: 64px;\n}\n\n.large {\n    width: 128px;\n    height: 128px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
